import { lazy } from "react";
import type { RouteObject } from "react-router";
import { SUPER_ADMIN_ROLES } from "@/src/audit/constants/audit.constants";
import { AUDIT_ROUTES } from "@/src/audit/constants/audit-routes.constants";
import { ProtectedRoute } from "@/src/auth/components/protected-route";

const AuditLogPage = lazy(() => import("@/src/audit/pages/audit-log.page"));

export const auditRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...SUPER_ADMIN_ROLES]} />,
		children: [{ path: AUDIT_ROUTES.audit, element: <AuditLogPage /> }],
	},
];
